import { useState } from 'react'
import { Stack, Typography, Grid, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useSites } from 'store'
import { toast } from 'components/global/CUK/Toast/Toast'
import useActions from 'pages/Auth/use-actions'

import { useModal } from 'store'
import Modal, { Header } from 'components/Modal';

export const TYPOLOGIES = [
  { name: 'retail', title: 'demo.topology.retail', icon: 'cart-shopping'},
  { name: 'hotel', title: 'demo.topology.hotel', icon: 'hotel'},
  { name: 'tents', title: 'demo.topology.tents', icon: 'tents'},
  { name: 'nurse', title: 'demo.topology.nurse', icon: 'user-nurse'},
  { name: 'graduation', title: 'demo.topology.graduation', icon: 'graduation-cap'},
]
const Sector = ({icon, title, name}) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {t} = useTranslation()
  const theme = useTheme()
  const [, setModal] = useModal()
  const [, setSites] = useSites()
  const {enterDemoMode} = useActions()
  const handleValid = async () => {
    setLoading(true)
    const {errors} = await enterDemoMode(name)
    if (!errors) {
      setModal(undefined)
      setSites(prev => ({...prev, focus: undefined, selected: [], accounts: []}))
      navigate('/auth/me')
    } else {
      toast.error(t('ui_elements.an_error_has_occurred'))
    }
    setLoading(false)
  }
  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      gap={3}
      p={4}
      sx={{
        borderRadius: 4,
        border: '1px solid #EFEFEF',
        cursor: loading ? 'default' : 'pointer',
        pointerEvents: loading ? 'none' : 'auto',
        '@keyframes bump': {
          '0%': { transform: 'scale(1)' },
          '50%': { transform: 'scale(1.1)' },
          '100%': { transform: 'scale(1)' },
        },
        animation: loading ? 'bump 0.5s ease-in-out infinite' : 'none',
        ...(loading && {backgroundColor: '#F7F7F7'}),
        '&:hover': {
          backgroundColor: '#F7F7F7'
        }
    }}
      onClick={!loading ? handleValid : () => {}}
      >
      <i className={`fa-solid fa-${icon}`} style={{color: theme.palette.primary.main, fontSize: 24}}/>
      <Typography component="span" sx={{ fontSize: 14, fontWeight: 500, color: 'content.secondary' }}>{title}</Typography>
    </Stack>
  )
}

const Demo = () => {
  const [, setModal] = useModal()
  const {t} = useTranslation()
  return (
    <Modal onClose={() => setModal(undefined)}>
      <Stack sx={{ position: 'relative', width: 624 }}>
        <Header icon={<i className="fa-solid fa-clapperboard-play" />} title={t('demo.title')} />
        <Typography component="span" sx={{ fontSize: 14, color: 'content.secondary', textAlign: 'center' }}>{t('demo.description')}</Typography>
        <Grid container spacing={3} mt={.5}>
          {
            TYPOLOGIES.map(typology => (
              <Grid item xs={4} key={typology.name}>
                <Sector name={typology.name} title={t(typology.title)} icon={typology.icon} />
              </Grid>
            ))
          }
        </Grid>
      </Stack>
    </Modal>
  )
}

export default Demo